
import { User } from "@supabase/supabase-js";

interface MessageConfigProps {
  fromWaitlist: boolean;
  isUnauthenticated: boolean;
  user: User | null;
}

interface MessageConfig {
  title: string;
  message: string;
  ctaText: string;
  ctaUrl: string;
  showRegistrationForm: boolean;
  secondaryCtaText?: string;
  secondaryCtaUrl?: string;
}

export function useMessageConfig({ fromWaitlist, isUnauthenticated, user }: MessageConfigProps): MessageConfig {
  if (fromWaitlist) {
    if (isUnauthenticated) {
      return {
        title: "Thank You for Your Submission",
        message: "Your waitlist submission has been received. To manage your waitlist preferences and receive updates about nursing home availability, please create your free account. We'll reach out to nursing homes on your behalf based on your preferences.",
        showRegistrationForm: true,
        ctaText: "Explore Nursing Homes",
        ctaUrl: "/nursing-homes"
      };
    }
    
    return {
      title: "Thank You for Your Submission",
      message: "We've received your waitlist registration and will be in touch shortly about nursing home options that match your needs. Our team is reviewing your preferences to provide you with the best care options. You can track the status of your request in your dashboard.",
      showRegistrationForm: false,
      ctaText: "View Your Dashboard",
      ctaUrl: "/dashboard",
      secondaryCtaText: "Return to Homepage",
      secondaryCtaUrl: "/"
    };
  }
  
  return {
    title: "Thank You",
    message: "Thank you for your interest in Grandpal services.",
    showRegistrationForm: false,
    ctaText: user ? "View Your Dashboard" : "Explore Nursing Homes",
    ctaUrl: user ? "/dashboard" : "/nursing-homes",
    secondaryCtaText: "Return to Homepage",
    secondaryCtaUrl: "/"
  };
}
